export default __webpack_public_path__ + "static/media/logo_full_color.2959a29c.png";